import firebase from "../../../firebase";

const INVALID_FIREBASE_KEY_CHARACTERS = /[.#$[\]/]/;

export async function deleteFileRecordAndNotifications(fileKey) {
    if (
        typeof fileKey !== "string" ||
        fileKey.trim() === "" ||
        INVALID_FIREBASE_KEY_CHARACTERS.test(fileKey)
    ) {
        throw new Error("A valid Firebase file key is required for deletion.");
    }

    const notificationsRef = firebase.database().ref("notifications");
    const snapshot = await notificationsRef
        .orderByChild("file")
        .equalTo(fileKey)
        .once("value");
    const updates = {
        [`files/${fileKey}`]: null,
    };

    snapshot.forEach((notificationSnapshot) => {
        if (notificationSnapshot.val()?.file === fileKey) {
            updates[`notifications/${notificationSnapshot.key}`] = null;
        }
    });

    await firebase.database().ref().update(updates);
}
